// 認証（Supabase Auth）：Googleサインイン＋許可アカウント制限。
// 制限の本丸はサーバ側（Supabase RLS ＝ public.veil_is_allowed()）と Functions/Worker の関門で強制する。
// 許可アカウントは個人Gmail等の場合があるため、Workspace 前提の hd ヒントは付けない。
import { supabase, supabaseReady } from './supabase.js'

// 認証状態の監視。onAuthStateChange は初回に現在セッションを通知するので、それで起動判定できる。
export function watchAuth(cb) {
  if (!supabaseReady) { cb(null); return () => {} }
  const { data } = supabase.auth.onAuthStateChange((_event, session) => cb(session && session.user ? session.user : null))
  // 保険: 初回セッションを即通知（onAuthStateChange の初回イベントが遅延する環境向け）
  supabase.auth.getSession().then(({ data: d }) => cb(d.session && d.session.user ? d.session.user : null)).catch(() => {})
  return () => { try { data.subscription.unsubscribe() } catch (e) {} }
}

// Googleでサインイン（リダイレクト方式・PKCE）。戻り先は現在オリジンのルート。
export async function login() {
  if (!supabaseReady) throw new Error('Supabase未設定です（.env を設定してください）')
  const { error } = await supabase.auth.signInWithOAuth({
    provider: 'google',
    options: { redirectTo: `${location.origin}/`, queryParams: { prompt: 'select_account' } },
  })
  if (error) throw error
  // ここでページは Google へリダイレクト → 戻り後に onAuthStateChange が発火する。
}

export function logout() {
  return supabaseReady ? supabase.auth.signOut() : Promise.resolve()
}

// 戻りURL等の認証エラーを取り出す（許可外アカウントはサーバ側で拒否＝エラーで戻る）。
export function authErrorFromUrl() {
  const h = new URLSearchParams((location.hash || '').replace(/^#/, ''))
  const q = new URLSearchParams(location.search || '')
  return h.get('error_description') || q.get('error_description') || h.get('error') || q.get('error') || null
}
